import React from "react";
import { motion } from "framer-motion";

export default function Process({ content }) {
  const p = content?.process || {};
  const steps = p.steps || [];

  return (
    <section id="processo" data-testid="process-section" className="py-24 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-16 max-w-2xl">
          <span className="label-mono text-peca-yellow">✳ {p.eyebrow}</span>
          <h2 className="mt-5 font-display font-extrabold uppercase text-4xl md:text-6xl tracking-tight leading-[0.95] text-peca-cream">
            {p.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-peca-line border border-peca-line">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              data-testid={`process-step-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="bg-peca-black p-8 min-h-[260px] flex flex-col group hover:bg-peca-surface transition-colors duration-300"
            >
              <span className="font-mono-p text-peca-yellow text-4xl md:text-5xl font-bold">{step.number}</span>
              <div className="mt-10">
                <h3 className="font-display font-bold uppercase text-xl md:text-2xl tracking-tight text-peca-cream mb-3 min-h-[2.5rem]">
                  {step.title}
                </h3>
                <p className="text-peca-grey text-sm leading-relaxed">{step.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
